import { useCallback } from 'react';

// Elegant swoosh sound for opening chat - professional and subtle
const OPEN_SOUND_URL = 'https://cdn.pixabay.com/audio/2023/10/30/audio_eff5eb12b9.mp3';
// Sophisticated notification chime for new messages - gentle and refined
const MESSAGE_SOUND_URL = 'https://cdn.pixabay.com/audio/2022/03/10/audio_4e2b03c859.mp3';

export const useChatSound = () => {
  const playSound = useCallback((type: 'open' | 'message') => {
    const audio = new Audio(type === 'open' ? OPEN_SOUND_URL : MESSAGE_SOUND_URL);
    audio.volume = 0.5; // Keep volume polite
    
    // Preload the audio for smoother playback
    audio.load();
    
    // Play and catch errors (browsers may block audio if user hasn't interacted with page yet)
    audio.play().catch((error) => {
      console.log('Audio playback blocked by browser:', error);
    });
  }, []);

  return { playSound };
};
